var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main-layout",staticStyle:{"width":"100%","float":"left"}},[(_vm.user && _vm.user.admin)?_c('admin-navbar'):_vm._e(),_vm._v(" "),_c('navbar'),_vm._v(" "),_c('div',{staticClass:"mt-4",staticStyle:{"width":"100%","float":"left"}},[_c('child')],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b407c932","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/layouts/default.vue
// module id = null
// module chunks = 